import { useEffect } from "react";

/**
 * Custom hook to block value change on number inputs
 * Prevent the number input value from changing when the user scrolls over it or uses the arrow keys
 */

export function useBlockNumberScroll() {
  useEffect(() => {
    const isNumberInput = (target) =>
      target instanceof HTMLInputElement &&
      target.type === "number" &&
      document.activeElement === target;

    const onWheel = (event) => {
      const target = event.target;
      if (isNumberInput(target)) {
        target.blur();
      }
    };

    const onKeyDown = (event) => {
      const target = event.target;
      if (isNumberInput(target) && (event.key === "ArrowUp" || event.key === "ArrowDown")) {
        event.preventDefault();
      }
    };

    document.addEventListener("wheel", onWheel, { passive: true });
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("wheel", onWheel);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, []);
}
